/**
 * Honduras Locations Data
 *
 * Departamentos y municipios de Honduras.
 * Fuente: División política administrativa oficial de Honduras.
 */

export interface Municipio {
  name: string;
}

export interface Departamento {
  name: string;
  municipios: Municipio[];
}

export const DEPARTAMENTOS: Departamento[] = [
  {
    name: "Atlántida",
    municipios: [
      { name: "La Ceiba" },
      { name: "El Porvenir" },
      { name: "Esparta" },
      { name: "Jutiapa" },
      { name: "La Masica" },
      { name: "San Francisco" },
      { name: "Tela" },
      { name: "Arizona" },
    ],
  },
  {
    name: "Choluteca",
    municipios: [
      { name: "Choluteca" },
      { name: "Apacilagua" },
      { name: "Concepción de María" },
      { name: "Duyure" },
      { name: "El Corpus" },
      { name: "El Triunfo" },
      { name: "Marcovia" },
      { name: "Morolica" },
      { name: "Namasigüe" },
      { name: "Orocuina" },
      { name: "Pespire" },
      { name: "San Antonio de Flores" },
      { name: "San Isidro" },
      { name: "San José" },
      { name: "San Marcos de Colón" },
      { name: "Santa Ana de Yusguare" },
    ],
  },
  {
    name: "Colón",
    municipios: [
      { name: "Trujillo" },
      { name: "Balfate" },
      { name: "Bonito Oriental" },
      { name: "Iriona" },
      { name: "Limón" },
      { name: "Sabá" },
      { name: "Santa Fe" },
      { name: "Santa Rosa de Aguán" },
      { name: "Sonaguera" },
      { name: "Tocoa" },
    ],
  },
  {
    name: "Comayagua",
    municipios: [
      { name: "Comayagua" },
      { name: "Ajuterique" },
      { name: "El Rosario" },
      { name: "Esquías" },
      { name: "Humuya" },
      { name: "La Libertad" },
      { name: "Lamaní" },
      { name: "La Trinidad" },
      { name: "Lejamaní" },
      { name: "Meámbar" },
      { name: "Minas de Oro" },
      { name: "Ojos de Agua" },
      { name: "San Jerónimo" },
      { name: "San José de Comayagua" },
      { name: "San José del Potrero" },
      { name: "San Luis" },
      { name: "San Sebastián" },
      { name: "Siguatepeque" },
      { name: "Villa de San Antonio" },
      { name: "Las Lajas" },
      { name: "Taulabé" },
    ],
  },
  {
    name: "Copán",
    municipios: [
      { name: "Santa Rosa de Copán" },
      { name: "Cabañas" },
      { name: "Concepción" },
      { name: "Copán Ruinas" },
      { name: "Corquín" },
      { name: "Cucuyagua" },
      { name: "Dolores" },
      { name: "Dulce Nombre" },
      { name: "El Paraíso" },
      { name: "Florida" },
      { name: "La Jigua" },
      { name: "La Unión" },
      { name: "Nueva Arcadia" },
      { name: "San Agustín" },
      { name: "San Antonio" },
      { name: "San Jerónimo" },
      { name: "San José" },
      { name: "San Juan de Opoa" },
      { name: "San Nicolás" },
      { name: "San Pedro" },
      { name: "Santa Rita" },
      { name: "Trinidad de Copán" },
      { name: "Veracruz" },
    ],
  },
  {
    name: "Cortés",
    municipios: [
      { name: "San Pedro Sula" },
      { name: "Choloma" },
      { name: "Omoa" },
      { name: "Pimienta" },
      { name: "Potrerillos" },
      { name: "Puerto Cortés" },
      { name: "San Antonio de Cortés" },
      { name: "San Francisco de Yojoa" },
      { name: "San Manuel" },
      { name: "Santa Cruz de Yojoa" },
      { name: "Villanueva" },
      { name: "La Lima" },
    ],
  },
  {
    name: "El Paraíso",
    municipios: [
      { name: "Yuscarán" },
      { name: "Alauca" },
      { name: "Danlí" },
      { name: "El Paraíso" },
      { name: "Güinope" },
      { name: "Jacaleapa" },
      { name: "Liure" },
      { name: "Morocelí" },
      { name: "Oropolí" },
      { name: "Potrerillos" },
      { name: "San Antonio de Flores" },
      { name: "San Lucas" },
      { name: "San Matías" },
      { name: "Soledad" },
      { name: "Teupasenti" },
      { name: "Texiguat" },
      { name: "Vado Ancho" },
      { name: "Yauyupe" },
      { name: "Trojes" },
    ],
  },
  {
    name: "Francisco Morazán",
    municipios: [
      { name: "Distrito Central (Tegucigalpa)" },
      { name: "Alubarén" },
      { name: "Cedros" },
      { name: "Curarén" },
      { name: "El Porvenir" },
      { name: "Guaimaca" },
      { name: "La Libertad" },
      { name: "La Venta" },
      { name: "Lepaterique" },
      { name: "Maraita" },
      { name: "Marale" },
      { name: "Nueva Armenia" },
      { name: "Ojojona" },
      { name: "Orica" },
      { name: "Reitoca" },
      { name: "Sabanagrande" },
      { name: "San Antonio de Oriente" },
      { name: "San Buenaventura" },
      { name: "San Ignacio" },
      { name: "San Juan de Flores" },
      { name: "San Miguelito" },
      { name: "Santa Ana" },
      { name: "Santa Lucía" },
      { name: "Talanga" },
      { name: "Tatumbla" },
      { name: "Valle de Ángeles" },
      { name: "Villa de San Francisco" },
      { name: "Vallecillo" },
    ],
  },
  {
    name: "Gracias a Dios",
    municipios: [
      { name: "Puerto Lempira" },
      { name: "Brus Laguna" },
      { name: "Ahuas" },
      { name: "Juan Francisco Bulnes" },
      { name: "Ramón Villeda Morales" },
      { name: "Wampusirpi" },
    ],
  },
  {
    name: "Intibucá",
    municipios: [
      { name: "La Esperanza" },
      { name: "Camasca" },
      { name: "Colomoncagua" },
      { name: "Concepción" },
      { name: "Dolores" },
      { name: "Intibucá" },
      { name: "Jesús de Otoro" },
      { name: "Magdalena" },
      { name: "Masaguara" },
      { name: "San Antonio" },
      { name: "San Isidro" },
      { name: "San Juan" },
      { name: "San Marcos de la Sierra" },
      { name: "San Miguel Guancapla" },
      { name: "Santa Lucía" },
      { name: "Yamaranguila" },
      { name: "San Francisco de Opalaca" },
    ],
  },
  {
    name: "Islas de la Bahía",
    municipios: [
      { name: "Roatán" },
      { name: "Guanaja" },
      { name: "José Santos Guardiola" },
      { name: "Utila" },
    ],
  },
  {
    name: "La Paz",
    municipios: [
      { name: "La Paz" },
      { name: "Aguanqueterique" },
      { name: "Cabañas" },
      { name: "Cane" },
      { name: "Chinacla" },
      { name: "Guajiquiro" },
      { name: "Lauterique" },
      { name: "Marcala" },
      { name: "Mercedes de Oriente" },
      { name: "Opatoro" },
      { name: "San Antonio del Norte" },
      { name: "San José" },
      { name: "San Juan" },
      { name: "San Pedro de Tutule" },
      { name: "Santa Ana" },
      { name: "Santa Elena" },
      { name: "Santa María" },
      { name: "Santiago de Puringla" },
      { name: "Yarula" },
    ],
  },
  {
    name: "Lempira",
    municipios: [
      { name: "Gracias" },
      { name: "Belén" },
      { name: "Candelaria" },
      { name: "Cololaca" },
      { name: "Erandique" },
      { name: "Gualcince" },
      { name: "Guarita" },
      { name: "La Campa" },
      { name: "La Iguala" },
      { name: "Las Flores" },
      { name: "La Unión" },
      { name: "La Virtud" },
      { name: "Lepaera" },
      { name: "Mapulaca" },
      { name: "Piraera" },
      { name: "San Andrés" },
      { name: "San Francisco" },
      { name: "San Juan Guarita" },
      { name: "San Manuel Colohete" },
      { name: "San Rafael" },
      { name: "San Sebastián" },
      { name: "Santa Cruz" },
      { name: "Talgua" },
      { name: "Tambla" },
      { name: "Tomalá" },
      { name: "Valladolid" },
      { name: "Virginia" },
      { name: "San Marcos de Caiquín" },
    ],
  },
  {
    name: "Ocotepeque",
    municipios: [
      { name: "Ocotepeque" },
      { name: "Belén Gualcho" },
      { name: "Concepción" },
      { name: "Dolores Merendón" },
      { name: "Fraternidad" },
      { name: "La Encarnación" },
      { name: "La Labor" },
      { name: "Lucerna" },
      { name: "Mercedes" },
      { name: "San Fernando" },
      { name: "San Francisco del Valle" },
      { name: "San Jorge" },
      { name: "San Marcos" },
      { name: "Santa Fe" },
      { name: "Sensenti" },
      { name: "Sinuapa" },
    ],
  },
  {
    name: "Olancho",
    municipios: [
      { name: "Juticalpa" },
      { name: "Campamento" },
      { name: "Catacamas" },
      { name: "Concordia" },
      { name: "Dulce Nombre de Culmí" },
      { name: "El Rosario" },
      { name: "Esquipulas del Norte" },
      { name: "Gualaco" },
      { name: "Guarizama" },
      { name: "Guata" },
      { name: "Guayape" },
      { name: "Jano" },
      { name: "La Unión" },
      { name: "Mangulile" },
      { name: "Manto" },
      { name: "Salamá" },
      { name: "San Esteban" },
      { name: "San Francisco de Becerra" },
      { name: "San Francisco de la Paz" },
      { name: "Santa María del Real" },
      { name: "Silca" },
      { name: "Yocón" },
      { name: "Patuca" },
    ],
  },
  {
    name: "Santa Bárbara",
    municipios: [
      { name: "Santa Bárbara" },
      { name: "Arada" },
      { name: "Atima" },
      { name: "Azacualpa" },
      { name: "Ceguaca" },
      { name: "Concepción del Norte" },
      { name: "Concepción del Sur" },
      { name: "Chinda" },
      { name: "El Níspero" },
      { name: "Gualala" },
      { name: "Ilama" },
      { name: "Las Vegas" },
      { name: "Macuelizo" },
      { name: "Naranjito" },
      { name: "Nuevo Celilac" },
      { name: "Petoa" },
      { name: "Protección" },
      { name: "Quimistán" },
      { name: "San Francisco de Ojuera" },
      { name: "San José de Colinas" },
      { name: "San Luis" },
      { name: "San Marcos" },
      { name: "San Nicolás" },
      { name: "San Pedro Zacapa" },
      { name: "San Vicente Centenario" },
      { name: "Santa Rita" },
      { name: "Trinidad" },
    ],
  },
  {
    name: "Valle",
    municipios: [
      { name: "Nacaome" },
      { name: "Alianza" },
      { name: "Amapala" },
      { name: "Aramecina" },
      { name: "Caridad" },
      { name: "Goascorán" },
      { name: "Langue" },
      { name: "San Francisco de Coray" },
      { name: "San Lorenzo" },
    ],
  },
  {
    name: "Yoro",
    municipios: [
      { name: "Yoro" },
      { name: "Arenal" },
      { name: "El Negrito" },
      { name: "El Progreso" },
      { name: "Jocón" },
      { name: "Morazán" },
      { name: "Olanchito" },
      { name: "Santa Rita" },
      { name: "Sulaco" },
      { name: "Victoria" },
      { name: "Yorito" },
    ],
  },
];

/**
 * Obtiene la lista de nombres de departamentos
 */
export function getDepartamentos(): string[] {
  return DEPARTAMENTOS.map((d) => d.name).sort();
}

/**
 * Obtiene los municipios de un departamento específico
 */
export function getMunicipios(departamento: string): string[] {
  const dept = DEPARTAMENTOS.find((d) => d.name === departamento);
  return dept ? dept.municipios.map((m) => m.name).sort() : [];
}
